export interface TipoResponsavelModel {
  nome?: string;
  descricao?: string;
}

export const tiposResponsavelList: TipoResponsavelModel[] = [
  { nome: "FINANCEIRO", descricao: "Financeiro" },
  { nome: "CORRETOR", descricao: "Corretor" },
  { nome: "OPERACIONAL", descricao: "Operacional" },
  { nome: "ASSOCIACAO", descricao: "Associação" },
  { nome: "REPRESENTANTE", descricao: "Representante" },
  { nome: "ASSESSORIA", descricao: "Assessoria" },
];